module.exports = __webpack_public_path__ + "img/ViewModuleOutlined.bd16197a.svg";